<template>
  <div class=" w-full py-4">
          <p class=" text-sm text-gray-400  text-center">©️2021 Sheldon Zhang </p>
        </div>
</template>

<script>
export default {
    name: "Footer"
}
</script>

<style>

</style>